import React from 'react'



function ReportIndex() {
 return(
  <div className='w-full h-full px-4 py-2'>
  <div className='w-full h-[calc(100vh-160px)] bg-white mt-1 rounded-lg shadow-lg overflow-hidden'>

  </div>
  </div>
 )
}

export default ReportIndex
